<ng-container>
  <div class="row mt-4">
    <div class="lp-dashboard-container">

      <div class="col-12 landing-page-container">
        <h1 class="c-g-headers fw-bold wrapper-header">CGP RevisionHub</h1>
        <div class="mt-1">
          <p class="fs-6">
            <a class="external-link cgp-link"
               (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/revision-hub/info`)">CGP
              RevisionHub</a>
            is full of superb online revision, all matched to your books! Choose a book to get
            started or have a go with our free samples.
          </p>

          <h3 class="fw-bold mt-4 wrapper-header">Got an Activation Code?</h3>
          <p> If you have an activation code for a book with CGP RevisionHub, enter it here...
          </p>
          <p><a class="external-link btn btn-default"
                (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/revision-hub/unlock`)">
            Enter a code
          </a></p>
<!--          @if (!isLoadingLicences() && !errorMessage() && digitalLicences().length === 0) {-->
<!--            <div-->
<!--              class="d-flex flex-column align-items-center justify-content-center py-5 product-block">-->
<!--              <p class="text-muted">Ooops, looks like you don’t have a book with a RevisionHub, have a look at our RevisionHub products or contact our helpful Customer Services Team.</p>-->
<!--            </div>-->
<!--          }-->
        </div>
      </div>

      <div class="lp-grid-container">
        <div class="book-cover-grid mt-4">

          @if (sessionStore.isLoggedInSignal()) {
            @if (isLoadingLicences()) {
              <div
                class="d-flex flex-column align-items-center justify-content-center py-5 loading-licences product-block">
                <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                  <span class="visually-hidden">Loading licences...</span>
                </div>
                <p class="mt-3 text-muted">Loading your licences&hellip;</p>
              </div>
            }
            @if (errorMessage()) {
              <div class="text-center text-danger">{{ errorMessage() }}</div>
            }
            @if (digitalLicences().length > 0) {
              @for (licence of digitalLicences(); track licence.digitalLicenceId) {
                <div class="text-center product-block">
                  <a routerLink="/products/{{hubCode(licence)}}" class="temporary-licence">
                    <div class="image-container">
                      <span class="prod__badge">New</span>
                      <img
                        src="/assets/images/products/{{licence.rootSkuNumber.toLowerCase()}}d-cover.jpg"
                        class="img-fluid cover-image" alt="{{licence.rootSkuNumber}}"
                        (error)="onImgError($event)">
                    </div>
                  </a>
                </div>
              }
            }
          }

          <div class="text-center product-block" [class.sample-locked]="false">
            <a routerLink="/samples/bar47" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/bar47dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our Biology revision books"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block" [class.sample-locked]="false">
            <a routerLink="/samples/car47" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/car47dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our Chemistry revision books"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block" [class.sample-locked]="false">
            <a routerLink="/samples/enar43" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/enar43dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our English revision books"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block">
            <a [routerLink]="'/samples/das43'" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/das43dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our German revision books"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block">
            <a [routerLink]="'/samples/spas43'" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/spas43dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our Spanish revision books."
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block">
            <a [routerLink]="'/samples/paq43'" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/paq43dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our Physics Exam Practice Workbooks"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
          <div class="text-center product-block">
            <a [routerLink]="'/samples/scahs43'" class="temporary-licence">
              <div class="image-container">
                <img
                  src="/assets/images/samples/scahs43dd-cover.jpg"
                  class="img-fluid cover-image" alt="Try some of the online revision included with our Combined Science revision books"
                  (error)="onImgError($event)">
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 px-4 mt-5">
        <p class="fs-6">
          Having problems with CGP RevisionHub? <a class="link-info external-link cgp-link"
                                                   routerLink="/frequently-asked-questions">These FAQs</a> should have
          the
          answer.</p>

        <p class="fs-6">
          Go to <a class="link-info external-link cgp-link"
                   (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/bookspacedemo`)">Your
          Online Library</a> to see the rest of your Online Editions</p>
      </div>

    </div>
  </div>
</ng-container>
